import { render } from "./notice-pattern-delete.vue?vue&type=template&id=96fc1a7e"
import script from "./notice-pattern-delete.vue?vue&type=script&lang=js"
export * from "./notice-pattern-delete.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__